import { BehaviorSubject, Subject } from "rxjs";

export abstract class BaseList<T> {
  private _add$ = new Subject<T>();
  private _remove$ = new Subject<T>();
  private _items$ = new BehaviorSubject<Array<T>>([]);

  protected get items() {
    return this._items$.value;
  }

  protected get items$() {
    return this._items$;
  }

  get add$() {
    return this._add$.asObservable();
  }

  get remove$() {
    return this._remove$.asObservable();
  }

  set(items: T[]) {
    this._items$.next(items);
  }

  add(item: T) {
    const items = this._items$.value.filter((_) => this.compare(_, item) !== 0);

    this._items$.next([...items, item]);

    this._add$.next(item);
  }

  remove(item: T) {
    const items = this._items$.value.filter((_) => this.compare(item, _) !== 0);

    this._items$.next(items);

    this._remove$.next(item);
  }

  abstract compare(item1: T, item2: T): number;
}
